import React from 'react';
import edsiderLogo from "../../../assets/images/edsiderlogo.png";
import './AssessmentInfoCard.css';

const AssessmentInfoCard = ({ details }) => {
  if (!details) return null;

  const {
    author,
    author_type,
    grade,
    term,
    time_duration,
    subject,
    medium,
    show_logo,
    logo_content,
    exam_category,
    year,
  } = details;

  const topAuthorTypes = ["School", "Zone", "Province", "Publication"];
  const showAuthorOnTop = topAuthorTypes.includes(author_type);

  return (
    <div className="ph-assessment-card border border-dark">
      <div className="d-flex w-100">
        {/* Left Logo */}
        <div className="ph-logo-container border-end border-dark">
          <img src={edsiderLogo} alt="Edsider Logo" className="ph-logo" />
        </div>

        {/* Center Content */}
        <div className="flex-grow-1 d-flex flex-column justify-content-between">
          <div className="ph-details-container border-start-0 border-end-0 border-dark border-bottom px-3 py-2">
            {/* Top Author if applicable */}
            {showAuthorOnTop ?<div className="ph-author-top text-center fw-bold text-uppercase mb-1">
              { author }
            </div> : null}

            {/* Exam Title */}
            <div className="ph-grade-term text-center fw-bold text-uppercase">
              {grade} - {term} {exam_category} {year ? `- ${year}` : ""}
            </div>
          </div>

          {/* Subject / Medium / Duration Row */}
          <div className="ph-info-row d-flex border-top border-dark">
            <div className="ph-info-cell border-end border-dark">
              {medium} Medium
            </div>
            <div className="ph-info-cell border-end border-dark">
              {subject}
            </div>
            <div className="ph-info-cell">
              Duration: {time_duration}
            </div>
            {!showAuthorOnTop ? (
              <div className="ph-info-cell">
                Provided by: {author || 'N/A'}
              </div>
            ) : null}
          </div>
        </div>

        {/* Right Logo (if exists) */}
        {show_logo && logo_content ? (
          <div className="ph-logo-container-right border-start border-dark">
            <img src={logo_content} alt="School Logo" className="ph-logo-school" />
          </div>
        ) : null}

      </div>
    </div>
  );
};

export default AssessmentInfoCard;
